import React, { Component } from 'react';
import {OrdinalFrame} from "semiotic";

class ScrollyTextBox extends Component {

    render() {
        return (
            <div className="text-box-wrapper" ref={this.props.innerRef}>
                <div className={"scrolly-text-box" + (this.props.active ? " active" : "")} style={{borderLeftColor: this.props.color}}>
                    <h1>{this.props.title}</h1>
                    <p>{this.props.description}</p>
                      {
                        (this.props.href != null) ?
                          (<div style={{float: "right"}}>
                              <a href={this.props.href}>[{this.props.id}]</a>
                          </div>)
                        : null
                      }
                </div>
            </div>
        );
    }
}

export default ScrollyTextBox;



// WEBPACK FOOTER //
// ./src/ScrollyTextBox.jsx